import { render, staticRenderFns } from "./BookMatchMain.vue?vue&type=template&id=589c5d98&scoped=true&"
import script from "./BookMatchMain.vue?vue&type=script&lang=js&"
export * from "./BookMatchMain.vue?vue&type=script&lang=js&"
import style0 from "./BookMatchMain.vue?vue&type=style&index=0&id=589c5d98&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589c5d98",
  null
  
)

export default component.exports